import { APPINDICATORS } from '../constants';

export const setPageLoading = () => ({ type: APPINDICATORS.PAGE_LOADING });
export const setPageLoadingFinished = () => ({
  type: APPINDICATORS.PAGE_LOADING_FINISHED,
});
